import NoMunicipalityRoutes from 'js/vue-plugins/vue-router/routes/no-municipality'
import CustomNoMunicipalityRoutes from 'js/vue-plugins/vue-router/routes/custom-no-municipality'
import MunicipalityRoutes from 'js/vue-plugins/vue-router/routes/municipalities/index'
import SystemRoutes from 'js/vue-plugins/vue-router/routes/system'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: HOME_ROUTE },
  },
  ...normalizeRoutes(NoMunicipalityRoutes),
  ...normalizeRoutes(CustomNoMunicipalityRoutes),
  ...normalizeRoutes(MunicipalityRoutes),
  ...normalizeRoutes(SystemRoutes),
]

export default routes
